export default __webpack_public_path__ + "static/snort-2ff6b2f44d225b2422b3fbc77f4354a0.png";